import { LOCALES } from './types';

export enum PROD_SUPPORTED_LOCALES {
  en_us = LOCALES.en_us,
  en_ca = LOCALES.en_ca,
  fr_ca = LOCALES.fr_ca,
}

export const SORTED_PROD_SUPPORTED_LOCALES = [LOCALES.en_ca, LOCALES.fr_ca, LOCALES.en_us];
